/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

export const CLIENT = 'CLIENT';
export const AGENT = 'AGENT';
export const TALENT = 'TALENT';
export const INFLUENCER = 'INFLUENCER';
export const PHOTOGRAPHER = 'PHOTOGRAPHER';
export const MODEL = 'MODEL';
export const HEAD_STYLIST = 'HEAD_STYLIST';
export const CLOTHING_STYLIST = 'CLOTHING_STYLIST';
export const HAIR_STYLIST = 'HAIR_STYLIST';
export const MAKEUP_STYLIST = 'MAKEUP_STYLIST';
export const TALENT_TYPES = [
  MODEL,
  PHOTOGRAPHER,
  CLOTHING_STYLIST,
  HAIR_STYLIST,
  MAKEUP_STYLIST,
];

export const SET_TYPE = 'SET_TYPE';

/**
 * Action that defines the type of user.
 *
 * @param {('CLIENT'|'TALENT')} type
 *
 * @return {Object}
 */
export const setSignupType = type => ({
  type: SET_TYPE,
  payload: { type },
});

export const SET_TALENT_TYPE = 'SET_TALENT_TYPE';

/**
 * Action that defines the type of client.
 *
 * @param {('CLIENT'|'MODEL'|'INFLUENCER'|'PHOTOGRAPHER'|'HEAD_STYLIST'|'CLOTHING_STYLIST')} type
 *
 * @return {Object}
 */
export const setTalentType = type => ({
  type: SET_TALENT_TYPE,
  payload: { type },
});

export const SET_INVITE_ID = 'SET_INVITE_ID';

/**
 * Action that defines the invite id.
 *
 * @param {string} id - The invite id.
 *
 * @return {Object}
 */
export const setInviteId = invite => ({
  type: SET_INVITE_ID,
  payload: { invite },
});

/**
 *
 * Action to show signup modal with type client
 */

export const SHOW_SIGNUP_MODAL_CLIENT = 'SHOW_SIGNUP_MODAL_CLIENT';

export const showSignupModalClient = () => ({
  type: SHOW_SIGNUP_MODAL_CLIENT,
});

export const SHOW_SIGNUP_MODAL = 'SHOW_SIGNUP_MODAL';

/**
 * Action that shows the signup modal.
 *
 * @return {Object}
 */
export const showSignupModal = () => ({
  type: SHOW_SIGNUP_MODAL,
});

export const HIDE_SIGNUP_MODAL = 'HIDE_SIGNUP_MODAL';

/**
 * Action that hides the signup modal.
 *
 * @return {Object}
 */
export const hideSignupModal = () => ({
  type: HIDE_SIGNUP_MODAL,
});
